import apiService from "./ApiService"

class ArquivoService {
  async upload(arquivo) {
    const formData = new FormData()
    formData.append('file', arquivo)

    try {
      return await apiService.post('arquivo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async view(idArquivo) {
    return await apiService.get(`arquivo/${idArquivo}/view`)
  }
}

const arquivoService = new ArquivoService()
export default arquivoService